export default "__VITE_ASSET__DTrT72iR__"